// extracted by mini-css-extract-plugin
export default {"navigation":"zUy5L","navigation_hidden":"zBHjR","navigation__controls":"emsnb","navigation__button":"eZvIu"};